/** ストレージの永続化と使用量（仕様書 §15.5・§16.4）。 */

const ASKED_KEY = 'nj.persistAsked';

export async function isPersisted(): Promise<boolean> {
  if (!navigator.storage?.persisted) return false;
  try {
    return await navigator.storage.persisted();
  } catch {
    return false;
  }
}

/**
 * 永続化を要求する。
 * iOSの未インストールPWAはストレージが破棄されうるため、早い段階で要求しておく。
 */
export async function requestPersist(): Promise<boolean> {
  if (!navigator.storage?.persist) return false;
  try {
    if (await isPersisted()) return true;
    const granted = await navigator.storage.persist();
    localStorage.setItem(ASKED_KEY, '1');
    return granted;
  } catch {
    return false;
  }
}

export async function requestPersistOnce(): Promise<void> {
  if (localStorage.getItem(ASKED_KEY)) return;
  await requestPersist();
}

export interface StorageUsage {
  usage: number;
  quota: number;
}

export async function estimateStorage(): Promise<StorageUsage | null> {
  if (!navigator.storage?.estimate) return null;
  try {
    const { usage = 0, quota = 0 } = await navigator.storage.estimate();
    return { usage, quota };
  } catch {
    return null;
  }
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}
